module.exports = __webpack_public_path__ + "static/media/pr-5.1b91e621.jpeg";